import React from 'react';
import Img from 'react-image';
import classNames from 'classnames/bind';

import styles from './sun.module.scss';
import Logo from '../../img/logo_telus.png';

let cx = classNames.bind(styles);

const Sun = () => {
	return (
		<section id='sun' className={cx({ sun: true })}>
			<div className='flex flex-col w-full'>
				<div
					className={cx({
						background: true,
						'flex flex-row w-full lg:justify-start items-end lg:items-center': true,
					})}
				>
					<div className='w-auto h-auto justify-center items-start bg-white pl-10 pr-20'>
						<h1 className='font-HelveticaNeueLTStd-Bold text-telus-purple text-3xl text-center lg:text-left lg:text-5xl leading-none pt-10'> It's different here</h1>
						<Img src={Logo} className='w-auto' />
					</div>
				</div>
			</div>
		</section>
	);
};

export default Sun;
